import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBranding } from '../../branding/BrandingContext';
import { ensureActiveSession } from '../../services/session';
import { isInitialSetupPending } from '../../services/initialSetup';
import './CheckoutResult.css';

const RETRY_INTERVAL_MS = 250;
const MAX_RETRIES = 40;
const SESSION_REFRESH_INTERVAL_MS = 1500;
const MAX_SESSION_REFRESH_RETRIES = 4;

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const branding = useBranding();
  const isAtendabotBrand = branding?.key === 'atendabot';
  const authenticatedPath = isAtendabotBrand
    ? branding?.authenticatedPath || '/atendabot'
    : '/products';

  useEffect(() => {
    let retries = 0;
    let timeoutId = null;
    let cancelled = false;
    let fbqTracked = false;
    let gtagTracked = false;

    const fireConversionEvents = () => {
      if (cancelled || typeof window === 'undefined') {
        return;
      }

      if (!fbqTracked && typeof window.fbq === 'function') {
        window.fbq('track', 'CompleteRegistration');
        window.fbq('track', 'StartTrial');
        fbqTracked = true;
      }

      if (!gtagTracked && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          send_to: 'AW-17972303669/JSRTCOSz3P0bELWu7vlC',
          value: 1.0,
          currency: 'BRL',
        });
        gtagTracked = true;
      }

      if ((fbqTracked && gtagTracked) || retries >= MAX_RETRIES) {
        return;
      }

      retries += 1;
      timeoutId = window.setTimeout(fireConversionEvents, RETRY_INTERVAL_MS);
    };

    fireConversionEvents();

    return () => {
      cancelled = true;
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    let timeoutId = null;
    let attempts = 0;

    const refreshSession = async () => {
      attempts += 1;
      await ensureActiveSession({ force: true }).catch(() => null);

      if (!cancelled && attempts < MAX_SESSION_REFRESH_RETRIES) {
        timeoutId = window.setTimeout(refreshSession, SESSION_REFRESH_INTERVAL_MS);
      }
    };

    refreshSession();

    return () => {
      cancelled = true;
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <div className="checkout-result">
      <div className="checkout-card">
        <span className="checkout-badge is-success">
          {isAtendabotBrand ? 'Ativação concluída' : 'Checkout concluído'}
        </span>
        <h1>{isAtendabotBrand ? 'AtendaBot ativado' : 'Assinatura confirmada'}</h1>
        {isAtendabotBrand ? (
          <p>
            Sua assinatura foi confirmada e o acesso ao AtendaBot já está disponível.
          </p>
        ) : (
          <p>
            Sua assinatura foi confirmada. Se você iniciou um trial, o acesso
            gratuito já está ativo pelo período configurado.
          </p>
        )}
        <div className="checkout-actions">
          <button
            className="primary"
            type="button"
            onClick={async () => {
              await ensureActiveSession({ force: true }).catch(() => null);
              navigate(!isAtendabotBrand && isInitialSetupPending()
                ? '/setup-inicial'
                : authenticatedPath);
            }}
          >
            {isAtendabotBrand
              ? 'Ir para o AtendaBot'
              : isInitialSetupPending()
                ? 'Configurar meu restaurante'
                : 'Ir para produtos'}
          </button>
          <button className="secondary" type="button" onClick={() => navigate('/')}>
            {isAtendabotBrand ? 'Voltar ao início' : 'Voltar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;
